import { isEqual } from 'lodash'
import { useRef } from 'react'

export const useDeepCompareMemo = <T>(value: T): T => {
  const ref = useRef<T>(value)

  if (!isEqual(ref.current, value)) {
    ref.current = value
  }

  return ref.current
}
